export class JsonUtils {
  /**
   * Checks whether a string is parseable as JSON, without throwing.
   *
   * @param value String to check.
   * @returns Whether the string is valid JSON.
   */
  public static isJson(value: string): boolean {
    try {
      JSON.parse(value);
      return true;
    } catch {
      return false;
    }
  }
}
